import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from '@emotion/styled/macro';
import {
  Button,
  Space,
  Table,
  Modal,
  Form,
  Divider,
  Select,
  Empty,
  Spin,
  InputNumber,
  Input,
  Switch,
  Checkbox,
  Col,
} from 'antd';
import { useQuery, useMutation, useLazyQuery } from '@apollo/react-hooks';
import { allPermissions, allRoles } from 'services';
import { notify, ValidateUser } from 'utilities';
import { ListHeader, PrimaryTitle, PrimaryButton, Can } from 'components';
import gql from 'graphql-tag';
import routes from '../../components/layout/routes';
import { array } from 'prop-types';
import { useTranslation } from 'react-i18next';

const { Item } = Form;

const RoleListContainer = styled.div``;

const RoleList = () => {
  ValidateUser();
  const history = useHistory();
  const [t, i18n] = useTranslation();
  const [form] = Form.useForm();
  const [role, setRole] = useState(0);
  const [creationFormVisible, setCreationFormVisible] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [defaultChecked, setDefaultChecked] = useState([]);
  const [page, setPage] = useState(1);

  const createRoleMutation = gql`
    mutation CreateRole($name: String!) {
      CreateRole(name: $name) {
        status
        message
      }
    }
  `;
  const editRoleMutation = gql`
    mutation UpdateRole($name: String!, $id: ID!) {
      UpdateRole(name: $name, id: $id) {
        status
        message
      }
    }
  `;
  const getRolePermission = gql`
    mutation getAllPermission($role_id: Int!) {
      getAllPermission(role_id: $role_id) {
        status
        message
        permissions {
          id
          name
          role_valid
        }
      }
    }
  `;
  const [createRole] = useMutation(createRoleMutation);
  const [UpdateRole] = useMutation(editRoleMutation);
  const { data, loading, fetchMore, refetch } = useQuery(allRoles, {
    variables: {
      first: 5,
      page: 1,
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });
  const [getPermissions, { loading: permissionLoading }] = useMutation(
    getRolePermission
  );

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
    },

    {
      title: 'Actions',
      render: (role) => {
        const EditButton = (
          <Button
            style={{ height: 18, padding: 0 }}
            type="link"
            onClick={() => {
              setRole(role);
              setEditFormVisible(true);
            }}
          >
            {t('Edit')}
          </Button>
        );
        const AssignButton = (
          <Button
            style={{ height: 18, padding: 0 }}
            type="link"
            onClick={() => {
              setRole(role);
              setperms();
            }}
          >
            {t('Assign Permission')}
          </Button>
        );

        const setperms = () => {
          getPermissions({
            variables: {
              role_id: role.id,
            },
          })
            .then(function (res) {
              let permissionData = res?.data?.getAllPermission?.permissions;
              let defaults = [];
              permissionData.map((perms) => {
                if (perms.role_valid) defaults.push(perms.id);
              });
              history.push({
                pathname: `/edit-role/${role.id}`,
                state: {
                  role: role,
                  permissions: permissionData,
                  defaultChecked: defaults,
                },
              });
            })
            .catch((err) => {
              console.log(err);
              if (err['graphQLErrors'][0]?.extensions) {
                const {
                  extensions: { validation },
                  message,
                } = err['graphQLErrors'][0];
                if (validation) {
                  for (let error in validation) {
                    notify('error', validation[error][0]);
                  }
                } else {
                  notify('error', message);
                }
              }
            });
        };
        return (
          <Space>
            <Can perform="CREAT_PERMISSION" yes={EditButton} />
            <Can perform="CREAT_PERMISSION" yes={AssignButton} />
          </Space>
        );
      },
    },
  ];
  //Translate Function For columns
  const ti81n = columns.map((ele) => {
    ele.title = t(ele.title);
  });

  const onCancel = () => {
    form.resetFields();
    setCreationFormVisible(false);
    setEditFormVisible(false);
    setPermissions({});
    setDefaultChecked([]);
  };

  const onSubmit = (values) => {
    const { name } = values;
    let correctName = name.split(' ').join('_');

    createRole({
      variables: {
        name: correctName,
      },
    })
      .then(function (res) {
        if (res.data?.CreateRole?.status === true)
          notify('success', res.data?.CreateRole?.message);
        refetch();
      })
      .catch((err) => {
        if (err['graphQLErrors'][0]?.extensions) {
          const {
            extensions: { validation },
            message,
          } = err['graphQLErrors'][0];
          if (validation) {
            for (let error in validation) {
              notify('error', validation[error][0]);
            }
          } else {
            notify('error', message);
          }
        }
      });

    setCreationFormVisible(false);
  };
  const onUpdate = (values) => {
    const { name } = values;
    let correctName = name.split(' ').join('_');
    UpdateRole({
      variables: {
        name: correctName,
        id: role.id,
      },
    })
      .then(function (res) {
        if (res.data?.UpdateRole?.status === true)
          notify('success', res.data?.UpdateRole?.message);
        refetch();
      })
      .catch((err) => {
        if (err['graphQLErrors'][0]?.extensions) {
          const {
            extensions: { validation },
            message,
          } = err['graphQLErrors'][0];
          if (validation) {
            for (let error in validation) {
              notify('error', validation[error][0]);
            }
          } else {
            notify('error', message);
          }
        }
      });

    setEditFormVisible(false);
  };

  /** Export Segments data in a downloadable file */

  return (
    <RoleListContainer>
      <Modal
        destroyOnClose
        visible={creationFormVisible}
        title={t('Create User role')}
        okText={t('Create')}
        cancelText={t('Cancel')}
        onCancel={onCancel}
        // confirmLoading={assigning}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onSubmit(values);
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="partners_form"
          preserve={false}
          initialValues={{ modifier: 'public' }}
        >
          <Item
            label={t('Name')}
            name="name"
            rules={[
              {
                required: true,
                message: t('Please, enter a valid name!'),
              },
            ]}
          >
            <Input></Input>
          </Item>
        </Form>
      </Modal>

      <Modal
        destroyOnClose
        visible={editFormVisible}
        title={'Update User role ' + role.name}
        okText={t('Update')}
        cancelText={t('Cancel')}
        onCancel={onCancel}
        // confirmLoading={assigning}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onUpdate(values);
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="partners_form"
          preserve={false}
          initialValues={{ modifier: 'public' }}
        >
          <Item
            label={t('Name')}
            name="name"
            rules={[
              {
                required: true,
                message: t('Please, enter a valid a new name !'),
              },
            ]}
          >
            <Input defaultValue={role.name}></Input>
          </Item>
        </Form>
      </Modal>
      <ListHeader>
        <PrimaryTitle style={{ flex: '1 1 0' }}>{t('role List')}</PrimaryTitle>

        <Can
          perform="CREAT_PERMISSION"
          yes={
            <PrimaryButton onClick={() => setCreationFormVisible(true)}>
              {t('Create role')}
            </PrimaryButton>
          }
        />
      </ListHeader>
      <Table
        bordered
        scroll={{ x: 400 }}
        dataSource={data?.allRoles?.data}
        columns={columns}
        loading={loading}
        rowKey="id"
        pagination={{
          total: data?.allRoles?.paginatorInfo?.total,
          pageSize: 5,
          showSizeChanger: false,
          onChange: (page) => {
            setPage(page);
            fetchMore({
              variables: {
                page,
              },
              updateQuery: (prev, { fetchMoreResult }) =>
                fetchMoreResult ? fetchMoreResult : prev,
            });
          },
        }}
      />
    </RoleListContainer>
  );
};

export default RoleList;
